import React from 'react';
import { FaFacebookF, FaInstagram, FaPhone, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import { ContentWrapper } from '../../utils/components';
import logoOrange from '../../../assets/images/logo_orange.png';
import '../../styles/Footer.css';

const Footer = () => {
  return (
    <footer className="garage-footer">
      <ContentWrapper>
        <div className="footer-top">
          <div className="footer-logo">
            <img src={logoOrange} alt="Auto-Service Thomas" />
            <p>Uw partner voor onderhoud, herstelling en diagnose</p>
          </div>
        </div>

        <div className="footer-middle">
          <div className="footer-block">
            <h4>Openingstijden</h4>
            <ul>
              <li>Ma - Do: 08:00 - 18:00 & 19:30 - 20:30</li>
              <li>Vr: 08:00 - 18:00</li>
              <li>Za: Enkel op afspraak</li>
              <li>Zo: Gesloten</li>
            </ul>
          </div>
          <div className="footer-block">
            <h4>Contact</h4>
            <p><FaPhone /> 0479 71 04 37</p>
            <p><FaEnvelope /> tho_vw@hotmail.com</p>
            <p><FaMapMarkerAlt /> Gentweg 26, 9940 Evergem</p>
          </div>
          <div className="footer-block">
            <h4>Volg ons</h4>
            <div className="footer-socials">
              <a href="https://www.facebook.com/autoservicethomas" target="_blank" rel="noreferrer">
                <FaFacebookF />
              </a>
              <a href="https://www.instagram.com/autoservicethomas/" target="_blank" rel="noreferrer">
                <FaInstagram />
              </a>
            </div>
          </div>
        </div>
      </ContentWrapper>
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Auto-Service Thomas. Alle rechten voorbehouden.</p>
      </div>
    </footer>
  );
};

export default Footer;
